import { get, post } from './Api';
const endpoint = 'inventory/allocation';

export const readList = async (data) => await post(`${endpoint}/read/list`, data);
export const getById = async (id) => await get(`${endpoint}/${id}`);
export const getAllocationData = async (id) => await get(`${endpoint}/data/${id}`);
export const getAllocationDataForInventoryItem = async (inventoryItemId) => await get(`${endpoint}/data/inventory-item/${inventoryItemId}`);
export const createAllocation = async (data) => await post(endpoint, data);
export const updateAllocation = async (data) => await post(`${endpoint}/update`, data);
export const getInventoryTagAllocations = async (inventoryTag) => await get(`${endpoint}/inventory-tag/${inventoryTag}`);
export const issueAllocation = async (id) => await get(`${endpoint}/issue/${id}`);
export const getStatuses = async () => await get(`${endpoint}/statuses`);

